module.exports = __webpack_public_path__ + "static/media/SM CLOUD.524d7c01.svg";